import type { AssociationResponse } from '~~/openapi-client/gen/schemas'
import type {
	findByMembershipAccountIdentifierResponse200,
} from '~~/openapi-client/gen/api/association-rest-controller/association-rest-controller'

const STORAGE_KEY = 'vc-selected-association'

const _selectedAssociationId = useSessionStorage<string | undefined>(STORAGE_KEY, undefined)

export default function useAssociations() {
	const { $api } = useNuxtApp()

	const { refresh, data: associations } = useAsyncData(
		'associations',
		() => $api.associationApi.findByMembershipAccountIdentifier(),
		{
			immediate: false,
			default: () => [] as AssociationResponse[],
			transform: (associations: findByMembershipAccountIdentifierResponse200) => (associations?.data) as AssociationResponse[] ?? undefined,
		},
	)

	const isEmpty = computed(() => associations.value?.length === 0)
	const hasMultipleAssociations = computed(() => (associations.value?.length ?? 0) > 1)

	const selectedAssociation = computed(() => {
		if (_selectedAssociationId.value) {
			const found = associations.value?.find(a => a.id === _selectedAssociationId.value)
			if (found) return found
		}
		if (associations.value?.length === 1) {
			return associations.value[0]
		}
		return undefined
	})

	const selectAssociation = (association: AssociationResponse) => {
		_selectedAssociationId.value = association.id
	}

	const clearSelection = () => {
		_selectedAssociationId.value = undefined
	}

	return {
		isEmpty,
		associations,
		selectedAssociation,
		hasMultipleAssociations,
		selectAssociation,
		clearSelection,
		refresh,
	}
}
